import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, FormGroup, Label } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchAndHandleProductUser } from '../../../../redux/css-admin/userManager/operations'
import lmsOperations from '../../../../redux/css-admin/lmsManager/operations'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import SelectLookup from '../../../../components/SelectLookup'
import { formatUserSuggestion } from '../../../../lib/util'

class UserSearch extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      notFound: false,
    }
  }

  search = async user => {
    const { fetchAndHandleProductUser, fetchTrainingStatusesCss } = this.props
    if (user) {
      fetchAndHandleProductUser(user.email, user.id)
      fetchTrainingStatusesCss(user.email)
    }
  }

  render = () => {
    const { props, state } = this

    return (
      <React.Fragment>
        <h2>User Search</h2>
        <hr />
        <ErrorBoundary>
          <Loading isLoading={props.isLoading} />
          <FormGroup>
            <Label>Email</Label>
            <SelectLookup
              apiVersion={2}
              formatSuggestion={formatUserSuggestion}
              onChange={this.search}
              placeholder={'Email'}
              searchEndpoint="profile/search"
              searchField="email"
            />
          </FormGroup>
          {state.notFound && <Alert color="warning">Not found</Alert>}
        </ErrorBoundary>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ userManager }) => {
  return {
    ...userManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAndHandleProductUser,
      ...lmsOperations,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSearch)



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/search/UserSearch.js